let wrapper = {}
if (typeof window !== 'undefined') {
  wrapper = window
}

export default wrapper
